import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab, TabList } from "@fluentui/react-components";
import { HomeRegular, CalendarRegular, ClockRegular, PeopleRegular, PersonRegular, BookRegular, ChatHelpRegular, } from "@fluentui/react-icons";
const navItems = [
    { key: "dashboard", label: "Tableau de bord", icon: _jsx(HomeRegular, {}) },
    { key: "absences", label: "Mes absences", icon: _jsx(CalendarRegular, {}) },
    { key: "badgeage", label: "Mes badgeages", icon: _jsx(ClockRegular, {}) },
    { key: "service", label: "Mon service", icon: _jsx(PeopleRegular, {}) },
    { key: "infos", label: "Mes informations", icon: _jsx(PersonRegular, {}) },
    { key: "parcours", label: "Mon parcours", icon: _jsx(BookRegular, {}) },
    { key: "aide", label: "Aide & contact", icon: _jsx(ChatHelpRegular, {}) },
];
export const EmployeeSideNav = ({ activeView, onNavigate }) => (_jsxs("nav", { style: {
        width: "200px",
        minHeight: "100vh",
        borderRight: "1px solid var(--colorNeutralStroke1, #e0e0e0)",
        padding: "16px 0",
        backgroundColor: "#f0f4ff",
    }, "aria-label": "Mon espace", children: [_jsx("div", { style: { padding: "0 16px 16px", fontWeight: 700, fontSize: "16px", color: "#0066cc" }, children: "Mon espace" }), _jsx(TabList, { vertical: true, selectedValue: activeView, onTabSelect: (_, data) => onNavigate(data.value), style: { width: "100%" }, children: navItems.map((item) => (_jsx(Tab, { value: item.key, icon: item.icon, "data-tour": `nav-${item.key}`, children: item.label }, item.key))) })] }));
